import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import DisplayResources from '../crud/DisplayResources';
import { resourceFields } from '../../data/Constants';
import LoadingBar from '../share/LoadingBar';

class Taxes extends Component {
  componentDidMount = () => {
    const {
      taxes, actions, loading, apiToken,
    } = this.props;

    if (loading === false && !taxes) {
      actions.getAllResources(apiToken, 'taxes');
    }
  }

  render() {
    const {
      taxes, actions, loading, apiToken,
    } = this.props;

    return (
      (loading === true)
        ? <LoadingBar />
        : (
          <DisplayResources
            data={taxes}
            actions={actions}
            fieldNames={resourceFields.taxes}
            resourceName="taxes"
            apiToken={apiToken}
          />
        )
    );
  }
}

Taxes.propTypes = {
  loading: PropTypes.bool.isRequired,
  taxes: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
};

Taxes.defaultProps = {
  taxes: null,
};

export default withRouter(Taxes);
